import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../Footer/Footer";
import Navbar from "../hero/Navbar";
import { DatePicker, Space } from "antd";
import "./RoomList.css";
import moment from "moment";
import dayjs from "dayjs";
import { AiFillDelete } from "react-icons/ai";
import { FaWifi, FaTv, FaSnowflake, FaBed, FaCheck } from "react-icons/fa";
import { BsTable } from "react-icons/bs";
import { useLocation } from "react-router-dom";
import * as Yup from "yup";
import { useFormik } from "formik";
import axios from "../../Utilities/axios";
import hotelplace from "../../assets/hotelplace.webp";
import { getHotelImage, getRoomTypeImage } from "../../assets/hotelImages";
import { connect } from "react-redux";
import { PaystackButton } from "react-paystack";
import {
  handleAddToCart,
  handleClearStore,
  GetCartData,
  handleRemoveFromCart,
  handleAdjustQty,
} from "../../Redux/Actions/room_actions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingSkeleton from "../../Utilities/LoadingSkeleton/LoadingSkeleton";
import RoomCarousel from "./RoomCarousel";
import HotelGallery from "./HotelGallery";
import { CalculateTax } from "../../Utilities/GeneralFunction";

const RoomList = ({
  handleAddToCart,
  handleClearStore,
  handleRemoveFromCart,
  handleAdjustQty,
  totalBills,
}) => {
  const bookingDetails = GetCartData();
  // console.log("bookingDetails", bookingDetails)

  const [dates, setDates] = useState([]);
  const [days, setDays] = useState(0);
  const [roomTypes, setRoomType] = useState([]);
  const [allRoom, setAllRoom] = useState();
  const [, setQuantity] = useState(bookingDetails.changeQty);
  const [hasErro, setHasErro] = useState(false);
  const [reference, setReference] = useState();
  const [payingGuest, setPayingGuest] = useState();
  const [submitted, setSubmitted] = useState(false);
  const [disAble, setDIsAble] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [bookArr, setBookArr] = useState([]);
  let [totalBillOnVat, settotalBillOnVatToPay] = useState(0);
  const [combinedTaxArray, setCombinedTaxArray] = useState([]);
  const { hotelId, hotelName } = useParams();
  //  let quantity = bookingDetails.qty

  const Navigate = useNavigate();

  const history = useLocation();

  const { RangePicker } = DatePicker;
  const dateFormat = "YYYY-MM-DD";
  const todayDate = new Date();
  const todayCorrectDate = moment(todayDate).format("YYYY-MM-DD HH:mm:ss");
  const tomorrowCorrectDate = moment()
    .add(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const dates2 = [todayCorrectDate, tomorrowCorrectDate];

  let date_1 = new Date(dates[0]);
  let date_2 = new Date(dates[1]);

  const dayz = (date_1, date_2) => {
    let difference = date_2.getTime() - date_1.getTime();
    let TotalDays = Math.floor(difference / (1000 * 3600 * 24));

    return TotalDays;
  };

  useEffect(() => {
    setDays(dayz(date_1, date_2));
  });

  // let totalBillOnVat;

  let numOfDays = days;

  // totalBillOnVat = totalBills * numOfDays;
  // Residency;
  useEffect(() => {
    const getHotels = async () => {
      const hotelDetails = await axios.get(
        `/registrations/hotels?sourceType=showInCompanySite&hotelGroupName=Residency`
      );

      const filterHotel = hotelDetails.data.find((e) => e.hotelId === hotelId);

      setRoomType(filterHotel);

      handleClearStore();
      setHasErro(false);
    };
    getHotels();
  }, []);

  const sourceType = "showInCompanySite";

  useEffect(() => {
    let selectedDateArr;
    let defDate2 = dates2[0];

    if (!dates || dates.length === 0) {
      const today = new Date();
      let tomorrow = new Date(dates2[1]);
      let tom = moment(tomorrow.setDate(today.getDate() + 1)).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      setDates([defDate2, tom]);
      selectedDateArr = [defDate2, tom];
    } else {
      selectedDateArr = dates;
      setDates(selectedDateArr);
    }

    const getRoomInfo = async () => {
      setIsLoading(true);
      const rooms = await axios.get(
        `/hotels/${hotelId}/roomAvailabilitySummary?startDate=${selectedDateArr[0]}&endDate=${selectedDateArr[1]}&sourceType=${sourceType}`
      );

      const combinedRooms = [];

      for (const room of rooms.data) {
        const [roomImage] = roomTypes.roomTypeImages.filter(
          (hotel) => hotel.roomTypeId == room.roomTypeId
        );

        if (roomImage) {
          combinedRooms.push({
            ...room,
            ...roomImage,
            taxLevies: roomTypes.taxLevies,
          });
        } else {
          combinedRooms.push({
            ...room,
            roomTypePicture: null,
            taxLevies: roomTypes.taxLevies,
          });
        }
      }

      setAllRoom(combinedRooms);

      setIsLoading(false);
    };
    getRoomInfo();
  }, [roomTypes]);

  const getRoomInfo2 = async (e) => {
    e.preventDefault();
    const rooms = await axios.get(
      `/hotels/${hotelId}/roomAvailabilitySummary?startDate=${dates[0]}&endDate=${dates[1]}&sourceType=${sourceType}`
    );

    const combinedRooms = [];

    for (const room of rooms.data) {
      const [roomImage] = roomTypes.roomTypeImages.filter(
        (hotel) => hotel.roomTypeId == room.roomTypeId
      );

      if (roomImage) {
        combinedRooms.push({
          ...room,
          ...roomImage,
          taxLevies: roomTypes.taxLevies,
        });
      } else {
        combinedRooms.push({
          ...room,
          roomTypePicture: null,
          taxLevies: roomTypes.taxLevies,
        });
      }
    }

    setAllRoom(combinedRooms);
  };

  //  console.log("dates", dates);

  const onChange = (value, dateString) => {
    console.log("Selected Time: ", value);
    console.log("Formatted Selected Time: ", dateString);
  };

  const onOk = (value) => {
    console.log("onOk: ", value);
  };

  const setRoomToStore = (room) => {
    handleAddToCart({
      ...room,
      type: "room",
      price: room.roomCost,
      addqty: setQuantity(1),
      lengthOfStay: days,
    });
    // console.log("bookingDetails", bookingDetails)
  };

  const onChangeHandler = (e, details) => {
    // console.log("e", e)

    setQuantity(bookingDetails.changeQty);
    handleAdjustQty(details.roomTypeId, e.target.value);
    if (details.availableRooms < e.target.value) {
      handleAdjustQty(details.roomTypeId, e.target.value);
      setHasErro(true);
      setQuantity(bookingDetails.changeQty);
      // quantity = details.availableRooms
      handleAdjustQty(details.roomTypeId, details.availableRooms);
    } else {
      setHasErro(false);
    }
  };

  const formik = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
      gender: "",
      guestTitle: "",
      address: "",
      tipTopGoGuestId: null,
      guestId: null,
      sourceType: "companySite",
    },
    validationSchema: Yup.object({
      firstName: Yup.string()
        .min(3, "first name must be more")
        .required("first name is Required"),
      lastName: Yup.string()
        .min(3, "last name is require")
        .required("last name is Required"),

      email: Yup.string()
        .email("invalid email address")
        .required("Email is Required"),

      phoneNumber: Yup.string()
        .matches(/^[0-9]*$/, "Phone number must only contain numbers")
        .max(14, "Must be 14 characters")
        .required("Phone number is required"),

      //  password: Yup.string().min(6, "password must be 6 characters").required("password is Required"),
      // country: Yup.string().max("please enter your country").required("country is Required"),
      guestTitle: Yup.string()
        .max(6, "please enter your title")
        .required("title is Required"),
      gender: Yup.string()
        .max(6, "please enter your gender")
        .required("gender is Required"),
      address: Yup.string()
        .max(100, "please enter your address")
        .required("address is Required"),
    }),

    onSubmit: async (values) => {
      setSubmitted(true);
      // setSubmitting(false);
      setPayingGuest(values);
    },
  });

  // payment implementation

  const config = {
    reference: new Date().getTime().toString(),
    email: formik.values.email,
    amount: totalBillOnVat * 100, //Amount is in the country's lowest currency. E.g Kobo, so 20000 kobo = N200
    // publicKey: 'pk_test_573cca83eaa8a37b2ac10bd98015fde5b4fe4df3'
    publicKey: "pk_live_b3304b8274925a6dd5479dc6972a3ce6adde2396",
  };

  // const bookArr = [];
  // for (const book of bookingDetails && bookingDetails) {
  //   bookArr.push({ ...book, quantity: book.qty });
  // }

  const handlePaystackSuccessAction = async (reference) => {
    // Implementation for whatever you want to do with reference and after success call.

    setReference(reference);
    const allBookingDetails = {
      payingGuest,
      paymentReference: reference.reference,
      totalBill: totalBillOnVat,
      paymentType: "paystack",
      showBreakfastLabel: false,
      breakfastCost: 0,
      reservationType: "booked",
      hotelName: roomTypes.hotelName,
      hotelId: roomTypes.hotelId,
      numOfDays: days,
      checkInDate: `${dates[0]} 15:00:00`,
      checkOutDate: `${dates[1]} 13:00:00`,
      guestId: null,
      bookingStatus: "unprocessed",
      referralName: "companySite",
      sourceType: "companySite",
      includeBreakfast: "1 breakfast",
      bookingId: "qMOuBxyiSPXXkwGOKVNmHn8V",
      hasTaxLevies: combinedTaxArray.length > 0 ? true : false,
      bookings: bookArr,
      paymentDetails: [
        {
          paymentType: "cash",
          amount: totalBillOnVat,
          bankName: "Select a Bank",
          transactionId: "",
          managerName: "",
          referenceNumber: "",
          creditId: "",
        },
      ],
    };
    // console.log('bookingValue', allBookingDetails);

    const notify = (res) => {
      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });

      let bookCode = res.data.bookingCode;

      setTimeout(() => {
        Navigate("/bookingSummary", {
          state: {
            allBookingDetails: allBookingDetails,
            roomTypes: roomTypes,
            bookCode: bookCode,
            taxDetails: combinedTaxArray,
          },
        });
      }, 3000);
    };

    await axios
      .post("/guests/makeWebReservation", allBookingDetails)
      .then((res) => {
        // notify(res);
        // console.log('ress from backend', res);
        notify(res);
        handleClearStore();
      })
      .catch((err) => console.log("the booking wasnt successfull", err));
  };

  const handlePaystackCloseAction = () => {
    // implementation for  whatever you want to do when the Paystack dialog closed.
    console.log("closed");
  };

  const componentProps = {
    ...config,
    text: "Pay Now",
    onSuccess: (reference) => handlePaystackSuccessAction(reference),
    onClose: handlePaystackCloseAction,
    // setReference(reference),
  };

  useEffect(() => {
    const addTaxToBooking = () => {
      const bookArray = [];
      let totalTaxAmounts = {};
      let totalTaxAmountsNoDiscount = {};
      let totalBillOnDiscountVat = 0;
      let totalBillOnVat = 0;
      let totalRoomCostNoVat = 0;
      for (const book of bookingDetails && bookingDetails) {
        const {
          totalTaxRoomCat,
          taxDetails,
          totalTaxRoomCatNoDiscount,
          taxDetailsNoDiscount,
        } = CalculateTax(book, days);

        const roomCostNoDiscount = book.roomCost * book.qty * days;

        const roomTotalBillNoDiscount = roomCostNoDiscount + totalTaxRoomCat;

       

        totalBillOnVat += roomTotalBillNoDiscount;

        taxDetails.forEach((taxDetail) => {
          const taxLabel = taxDetail.taxLabel;
          const amount = taxDetail.taxAmount || 0;
          const percentage = taxDetail.taxPercentage;
          const flatAmount = taxDetail.flatAmount;

          // Accumulate the amounts for the same tax label
          totalTaxAmounts[taxLabel] = totalTaxAmounts[taxLabel] || {
            amount: 0,
            details: {},
          };

          totalTaxAmounts[taxLabel].amount += amount;

          // Store the corresponding tax details (percentage or flatAmount)
          if (percentage !== null) {
            totalTaxAmounts[taxLabel].details = {
              value: percentage,
              type: "percentage",
            };
          } else if (flatAmount !== null) {
            totalTaxAmounts[taxLabel].details = {
              value: flatAmount,
              type: "flatAmount",
            };
          }
        });

        const totalTaxArray = Object.entries(totalTaxAmounts).map(
          ([taxLabel, { amount, details }]) => ({
            taxLabel,
            amount: Math.round(amount),
            percentageOrFlatAmount: details.value,
            type: details.type,
          })
        );

        setCombinedTaxArray(totalTaxArray);

        bookArray.push({
          ...book,
          // totalBreakfastCost: totalBreakfastCost || 0,
          quantity: book.qty,
          // showBreakfastLabel: showBreakFastLab,
          totalTaxRoomCat,
          taxDetails,
          totalRoomCostNoVat,
        });
      }

      
      settotalBillOnVatToPay(totalBillOnVat);

      setBookArr(bookArray);
    };
    addTaxToBooking();
  }, [bookingDetails]);

  // console.log("bookArr", bookArr);
  return (
    <div>
      <Navbar />

      <section className='rl-hero'>
        {roomTypes && (
          <>
            <img
              src={
                roomTypes.picture ||
                getHotelImage(roomTypes.hotelName) ||
                hotelplace
              }
              onError={(e) => {
                const match = getHotelImage(roomTypes.hotelName);
                if (match && e.target.src !== match) {
                  e.target.src = match;
                } else if (e.target.src !== hotelplace) {
                  e.target.src = hotelplace;
                }
              }}
              alt=''
              className='rl-hero__bg'
            />
            <div className='rl-hero__overlay' />
            <div className='container'>
              <div className='rl-hero__content'>
                <div className='rl-hero__eyebrow'>Residency Hotels</div>
                <h1 className='rl-hero__title'>{roomTypes.hotelName}</h1>
                <p className='rl-hero__desc'>
                  {roomTypes.hotelDescription}
                </p>
              </div>
            </div>
          </>
        )}
      </section>

      <div className='container rl-main'>
        <div className='row'>
          <div className='col-md-8'>
            <div className='rl-avail'>
              <form className='rl-avail__form'>
                <div className='rl-avail__dates'>
                  <span className='rl-avail__label'>Check-in / Check-out</span>
                  <div className='rl-avail__picker'>
                    <RangePicker
                      defaultValue={[
                        dayjs(dates2[0], dateFormat),
                        dayjs(dates2[1], dateFormat),
                      ]}
                      allowClear={false}
                      disabledDate={(current) => {
                        let customDate = moment().format("YYYY-MM-DD");
                        return (
                          current && current < moment(customDate, "YYYY-MM-DD")
                        );
                      }}
                      onChange={(valm) => {
                        handleClearStore();
                        setDates(
                          valm.map((item) => {
                            const selectedDate = new Date(item);
                            console.log(
                              "selectedDate",
                              moment(selectedDate).format("YYYY-MM-DD")
                            );
                            return moment(selectedDate).format("YYYY-MM-DD");
                          })
                        );
                      }}
                      onOk={onOk}
                      id='inlineFormInputGroup'
                      placeholder={["Check-in", "Check-out"]}
                    />
                  </div>
                </div>

                <button
                  type='button'
                  className='rl-btn rl-btn--check'
                  onClick={getRoomInfo2}
                >
                  Check Availability
                </button>
              </form>
            </div>
            <div className='rl-section-head'>
              <div className='rl-section-head__eyebrow'>Select your room</div>
              <h2>Available Rooms</h2>
            </div>

            {isLoading ? (
              <LoadingSkeleton />
            ) : (
              allRoom &&
              allRoom.map((room, i) => (
                <div className='rl-room-card' key={i}>
                  <div className='rl-room-card__media'>
                    <RoomCarousel
                      hotelName={roomTypes?.hotelName}
                      roomTypeName={room.roomTypeName}
                      apiPicture={room.roomTypePicture}
                      alt={room.roomTypeName}
                    />
                    {room.availableRooms === 0 ? (
                      <span className='rl-room-card__badge rl-room-card__badge--sold'>
                        Fully Booked
                      </span>
                    ) : room.availableRooms <= 5 ? (
                      <span className='rl-room-card__badge rl-room-card__badge--low'>
                        Only {room.availableRooms} left
                      </span>
                    ) : null}
                  </div>
                  <div className='rl-room-card__body'>
                    <div className='rl-room-card__head'>
                      <h3 className='rl-room-card__name'>
                        {room.roomTypeName}
                      </h3>
                      <div className='rl-room-card__price'>
                        <span className='rl-room-card__amount'>
                          &#8358; {room.roomCost.toLocaleString()}
                        </span>
                        <span className='rl-room-card__per'> / night</span>
                      </div>
                    </div>
                    <p className='rl-room-card__desc'>
                      {room.shortDescription}
                    </p>
                    <div className='rl-room-card__chips'>
                      <span className='rl-chip'>
                        <FaSnowflake /> AC
                      </span>
                      <span className='rl-chip'>
                        <FaWifi /> Free Wifi
                      </span>
                      <span className='rl-chip'>
                        <BsTable /> Table
                      </span>
                      <span className='rl-chip'>
                        <FaTv /> Television
                      </span>
                    </div>
                    <button
                      disabled={room.availableRooms === 0}
                      className='rl-btn rl-btn--select'
                      onClick={() => setRoomToStore(room)}
                    >
                      {room.availableRooms === 0
                        ? "Fully Booked"
                        : "Select Room"}
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>

          {/* selected room Details */}
          <div className='col-md-4'>
            <div className='rl-sidebar'>
              <div className='rl-booking'>
                <div className='rl-booking__head'>
                  <h3 className='rl-booking__title'>Your Reservation</h3>
                  <p className='rl-booking__stay'>
                    <FaBed />
                    {dates[0] && moment(dates[0]).format("MMM D")} –{" "}
                    {dates[1] && moment(dates[1]).format("MMM D, YYYY")} ·{" "}
                    {days} night{days === 1 ? "" : "s"}
                  </p>
                </div>
                <div className='rl-booking__body'>
                  {bookingDetails && bookingDetails.length > 0 ? (
                    <>
                      {bookingDetails.map((details, i) => (
                        <div className='rl-booking__item' key={i}>
                          <img
                            src={
                              details.roomTypePicture ||
                              getRoomTypeImage(
                                roomTypes?.hotelName,
                                details.roomTypeName
                              ) ||
                              getHotelImage(roomTypes?.hotelName) ||
                              hotelplace
                            }
                            onError={(e) => {
                              const roomImg = getRoomTypeImage(
                                roomTypes?.hotelName,
                                details.roomTypeName
                              );
                              if (roomImg && e.target.src !== roomImg) {
                                e.target.src = roomImg;
                              } else if (e.target.src !== hotelplace) {
                                e.target.src = hotelplace;
                              }
                            }}
                            className='rl-booking__thumb'
                            alt={details.roomTypeName}
                          />
                          <div className='rl-booking__item-info'>
                            <p className='rl-booking__item-name'>
                              {details.roomTypeName}
                            </p>
                            <p className='rl-booking__item-cost'>
                              &#8358;{" "}
                              {(details.totalCost * days).toLocaleString()}
                            </p>
                          </div>
                          <div className='rl-booking__item-actions'>
                            <div className='rl-qty'>
                              <button
                                type='button'
                                className='rl-qty__btn'
                                aria-label='Decrease quantity'
                                onClick={() =>
                                  handleAdjustQty(
                                    details.roomTypeId,
                                    Math.max(1, details.qty - 1)
                                  )
                                }
                              >
                                −
                              </button>
                              <span className='rl-qty__value'>
                                {details.qty}
                              </span>
                              <button
                                type='button'
                                className='rl-qty__btn'
                                aria-label='Increase quantity'
                                onClick={() =>
                                  onChangeHandler(
                                    {
                                      target: {
                                        value: details.qty + 1,
                                      },
                                    },
                                    details
                                  )
                                }
                              >
                                +
                              </button>
                            </div>
                            <button
                              type='button'
                              className='rl-booking__remove'
                              aria-label='Remove room'
                              onClick={() =>
                                handleRemoveFromCart(
                                  details.roomTypeId,
                                  setHasErro(false)
                                )
                              }
                            >
                              <AiFillDelete />
                            </button>
                          </div>
                        </div>
                      ))}

                      {hasErro && (
                        <p className='rl-booking__error'>
                          Quantity exceeds available rooms.
                        </p>
                      )}

                      {combinedTaxArray.length > 0 && (
                        <div className='rl-booking__tax'>
                          {combinedTaxArray.map((taxObject, i) => (
                            <div className='rl-booking__tax-row' key={i}>
                              <span>
                                {taxObject.taxLabel}(
                                {taxObject.percentageOrFlatAmount}
                                {taxObject.type === "flatAmount" ? "" : "%"})
                              </span>
                              <span>
                                &#8358; {taxObject.amount.toLocaleString()}
                              </span>
                            </div>
                          ))}
                        </div>
                      )}

                      <div className='rl-booking__total'>
                        <span>Total</span>
                        <span>
                          &#8358; {totalBillOnVat.toLocaleString()}
                        </span>
                      </div>
                    </>
                  ) : (
                    <div className='rl-booking__empty'>
                      <FaBed />
                      <p>
                        No rooms selected yet.
                        <br />
                        Pick a room to continue.
                      </p>
                    </div>
                  )}
                </div>
                <div className='rl-booking__foot'>
                  <button
                    type='button'
                    disabled={totalBillOnVat === 0}
                    className='rl-btn rl-btn--pay'
                    data-bs-toggle='modal'
                    data-bs-target='#staticBackdrop'
                  >
                    Proceed To Payment
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='container'>
        {roomTypes && (
          <div className='rl-section-head'>
            <div className='rl-section-head__eyebrow'>Explore the hotel</div>
            <h2>Gallery & Amenities</h2>
          </div>
        )}

        <HotelGallery
          hotelName={roomTypes && roomTypes.hotelName}
          hideHead
        />

        {roomTypes &&
          (roomTypes.hotelDescription ||
            (roomTypes.amenities && roomTypes.amenities.length > 0)) && (
            <div className='rl-hotel-info'>
              <div className='rl-hotel-info__panel'>
                {roomTypes.hotelDescription && (
                  <p className='rl-hotel-info__desc'>
                    {roomTypes.hotelDescription}
                  </p>
                )}
                {roomTypes.amenities && roomTypes.amenities.length > 0 && (
                  <div className='rl-hotel-info__amenities'>
                    <h4>Hotel Amenities</h4>
                    <div className='rl-hotel-info__chips'>
                      {roomTypes.amenities.map((a, i) => (
                        <span className='rl-chip' key={i}>
                          <FaCheck /> {a.amenity}
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
      </div>

      {/* modal */}
      <div
        className='modal fade rl-modal'
        id='staticBackdrop'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-dialog-scrollable'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title' id='staticBackdropLabel'>
                Guest Details
              </h1>
              <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              ></button>
            </div>
            <div className='modal-body'>
              <form onSubmit={formik.handleSubmit} className='rl-guest-form'>
                <div className='row'>
                  <div className='mb-3 col-md-6'>
                    <label htmlFor='guestTitle' className='rl-field__label'>
                      Title
                    </label>
                    <select
                      className='form-select rl-field'
                      aria-label='Select title'
                      name='guestTitle'
                      id='guestTitle'
                      value={formik.values.guestTitle}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option selected disabled value={""}>
                        select title
                      </option>
                      <option id='Mr' value='Mr'>
                        Mr
                      </option>
                      <option id='Mrs' value='Mrs'>
                        Mrs
                      </option>
                      <option id='Dr' value='Dr'>
                        Dr
                      </option>
                      <option id='Chief' value='Chief'>
                        Chief
                      </option>
                    </select>
                    {formik.touched.guestTitle && formik.errors.guestTitle ? (
                      <p className='error'>{formik.errors.guestTitle}</p>
                    ) : null}
                  </div>

                  <div className='mb-3 col-md-6'>
                    <label htmlFor='gender' className='rl-field__label'>
                      Gender
                    </label>
                    <select
                      className='form-select rl-field'
                      aria-label='Select gender'
                      name='gender'
                      id='gender'
                      value={formik.values.gender}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    >
                      <option selected disabled value={""}>
                        select gender
                      </option>
                      <option id='Male' value='Male'>
                        Male
                      </option>
                      <option id='Female' value='Female'>
                        Female
                      </option>
                    </select>
                    {formik.touched.gender && formik.errors.gender ? (
                      <p className='error'>{formik.errors.gender}</p>
                    ) : null}
                  </div>
                </div>

                <div className='row'>
                  <div className='mb-3 col-md-6'>
                    <label htmlFor='firstName' className='rl-field__label'>
                      First Name
                    </label>
                    <input
                      type='text'
                      className='form-control rl-field'
                      aria-describedby='emailHelp'
                      name='firstName'
                      id='firstName'
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.firstName && formik.errors.firstName ? (
                      <p className='error'>{formik.errors.firstName}</p>
                    ) : null}
                  </div>
                  <div className='mb-3 col-md-6'>
                    <label htmlFor='lastName' className='rl-field__label'>
                      Last Name
                    </label>
                    <input
                      type='text'
                      className='form-control rl-field'
                      aria-describedby='emailHelp'
                      name='lastName'
                      id='lastName'
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.lastName && formik.errors.lastName ? (
                      <p className='error'>{formik.errors.lastName}</p>
                    ) : null}
                  </div>
                </div>

                <div className='mb-3'>
                  <label htmlFor='email' className='rl-field__label'>
                    Email address
                  </label>
                  <input
                    type='email'
                    className='form-control rl-field'
                    aria-describedby='emailHelp'
                    name='email'
                    id='email'
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.email && formik.errors.email ? (
                    <p className='error'>{formik.errors.email}</p>
                  ) : null}

                  <div id='emailHelp' className='form-text'>
                    We'll never share your email with anyone else.
                  </div>
                </div>
                <div className='mb-3'>
                  <label htmlFor='phoneNumber' className='rl-field__label'>
                    Phone Number
                  </label>
                  <input
                    type='tel'
                    className='form-control rl-field'
                    name='phoneNumber'
                    id='phoneNumber'
                    value={formik.values.phoneNumber.trim()}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.phoneNumber && formik.errors.phoneNumber ? (
                    <p className='error'>{formik.errors.phoneNumber}</p>
                  ) : null}
                </div>
                <div className='mb-3'>
                  <label htmlFor='address' className='rl-field__label'>
                    Address
                  </label>
                  <textarea
                    className='form-control rl-field'
                    placeholder='Enter your address'
                    name='address'
                    id='address'
                    value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    style={{ height: "100px" }}
                  ></textarea>
                  {formik.touched.address && formik.errors.address ? (
                    <p className='error'>{formik.errors.address}</p>
                  ) : null}
                </div>

                <div className='modal-footer rl-modal__foot'>
                  <button
                    type='button'
                    className='btn rl-btn rl-btn--ghost'
                    data-bs-dismiss='modal'
                  >
                    Cancel
                  </button>
                  <button
                    type='submit'
                    className='btn rl-btn rl-btn--pay'
                    data-bs-toggle={submitted ? "modal" : ""}
                    data-bs-target='#staticBackdrop2 '
                    data-dismiss='modal'
                  >
                    Submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* second modal */}

      <div
        className='modal fade rl-modal'
        id='staticBackdrop2'
        data-bs-backdrop='static'
        data-bs-keyboard='false'
        tabIndex='-1'
        aria-labelledby='staticBackdropLabel'
        aria-hidden='true'
      >
        <div className='modal-dialog modal-lg modal-dialog-scrollable'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h1 className='modal-title' id='staticBackdropLabel'>
                Booking Summary
              </h1>
              <button
                type='button'
                className='btn-close'
                data-bs-dismiss='modal'
                aria-label='Close'
              ></button>
            </div>
            <div className='modal-body'>
              <div className='rl-summary'>
                <div className='rl-summary__guest'>
                  <div className='rl-summary__row'>
                    <span>Name</span>
                    <strong>
                      {formik.values.guestTitle} {formik.values.firstName}{" "}
                      {formik.values.lastName}
                    </strong>
                  </div>
                  <div className='rl-summary__row'>
                    <span>Phone Number</span>
                    <strong>{formik.values.phoneNumber}</strong>
                  </div>
                  <div className='rl-summary__row'>
                    <span>Email</span>
                    <strong>{formik.values.email}</strong>
                  </div>
                </div>

                <table className='table rl-summary__table'>
                  <thead>
                    <tr>
                      <th scope='col'>S/n</th>
                      <th scope='col'>Room Type</th>
                      <th scope='col'>Quantity</th>
                      <th scope='col'>Price</th>
                      <th scope='col'>Day(s)</th>
                      <th scope='col'>Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {bookingDetails &&
                      bookingDetails.map((selections, i) => (
                        <tr key={i}>
                          <th scope='row'>{i + 1}</th>
                          <td>{selections.roomTypeName}</td>
                          <td>X {selections.qty}</td>
                          <td>&#8358; {selections.roomCost.toLocaleString()}</td>
                          <td>{days}</td>
                          <td>
                            &#8358;{" "}
                            {(selections.totalCost * days).toLocaleString()}
                          </td>
                        </tr>
                      ))}
                    {combinedTaxArray &&
                      combinedTaxArray.map((taxObject) => (
                        <tr key={taxObject.taxLabel}>
                          <th scope='row'></th>
                          <td colSpan='2'>
                            {taxObject.taxLabel}(
                            {taxObject.percentageOrFlatAmount}
                            {taxObject.type === "flatAmount" ? "" : "%"})
                          </td>
                          <td colSpan='3' className='rl-summary__total-cell'>
                            &#8358; {taxObject.amount.toLocaleString()}
                          </td>
                        </tr>
                      ))}

                    <tr className='rl-summary__grand'>
                      <th scope='row'></th>
                      <td colSpan='2'>Total Payment:</td>
                      <td colSpan='3' className='rl-summary__grand-amount'>
                        &#8358; {totalBillOnVat.toLocaleString()}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className='modal-footer rl-modal__foot'>
              <button
                type='button'
                className='btn rl-btn rl-btn--ghost'
                data-bs-dismiss='modal'
              >
                Cancel
              </button>
              <button
                type='button'
                className='btn rl-btn rl-btn--pay'
                data-bs-dismiss='modal'
              >
                <PaystackButton {...componentProps} className='payNowBtn' />
              </button>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
      <Footer />
    </div>
  );
};

const calcQuickTotal = (items) => {
  if (items) {
    return items.reduce((a, b) => {
      if (b.discountRate) {
        return a + b.qty * b.price; // NB: b.discountPrice
      } else {
        return a + b.qty * b.price;
      }
    }, 0);
  }
  return 0;
};

const mapStateToProps = (state) => {
  const cart = state.rootReducer.cart;
  return {
    totalBills: calcQuickTotal(state.rootReducer.cart),
    cart,
  };
};
export default connect(mapStateToProps, {
  handleAddToCart,
  handleClearStore,
  handleRemoveFromCart,
  handleAdjustQty,
})(RoomList);
